// Copyright © 2021 Move Closer

import { AbstractTypeDriver } from './abstract'
import {
  DescriptionOfGallery, DriverConfig, RelatedRecord,
  RelatedType, ResolvesDriver
} from '../contracts'
import { ImageFile } from '../../../modules/_contracts'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class GalleryDriver<M extends Array<ImageFile> = ImageFile[], D extends DescriptionOfGallery = DescriptionOfGallery> extends AbstractTypeDriver<M, D> {
  /**
   * Key that stores RelatedType.
   * @protected
   */
  protected typeKey: RelatedType = RelatedType.Gallery

  /**
   * @inheritDoc
   */
  public resolve (id: string, record: RelatedRecord, config: DriverConfig, driverResolver: ResolvesDriver): M {
    const description = super.resolve(id, record, config, driverResolver) as unknown as DescriptionOfGallery

    return [
      ...description.items
    ] as unknown as M
  }
}
